<template>
  <div class="aboutcontent">
    <div class="aboutdbody">
      <div class="title">
        <p class="wow fadeInUp">{{titlename}}</p>
      </div>
      <div class="aboutbottom">
        <div class="divbox" v-for="(item,index) in listInt" v-show="index<3">
          <div>
            <div class="borderimg"  v-if="item.img== ''"></div>
            <img :src="getimgsrc(item.img)" v-else/>

            <p v-html="$i18n.locale=='zh_HK'?item.name:item.nameEn">{{$i18n.locale=='zh_HK'?item.name:item.nameEn}}</p>
          </div>
        </div>
      </div>
      <div class="aboutbottom">
        <div class="divbox" v-for="(item,index) in listInt" v-show="index>2">
          <div>
            <div  class="borderimg" v-if="item.img== ''"></div>
            <img :src="getimgsrc(item.img)" v-else/>
            <p v-html="$i18n.locale=='zh_HK'?item.name:item.nameEn">{{$i18n.locale=='zh_HK'?item.name:item.nameEn}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { WOW } from 'wowjs';
  export default {
    name: "comIntroduction",
    props: [ 'titlename','listInt'],
    mounted(){
      //解决---控制台可能会出现警告
      var options={
        //默认为true
        live:false
      }
      var wow = new WOW(options);
      wow.init();

    },
    methods: {
      getimgsrc(imgvalue){

        if (imgvalue == null || imgvalue == '') {
          return '-'
        }
        var imgs = imgvalue.replace(/,/g, "")
        return process.env.BASE_IMG + imgs
      }
    },
  }
</script>

<style lang="less" scoped>
  @media only screen and (min-width: 800px) {
    .aboutcontent {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 5%;
      .title {
        padding-top: 4% ;
        height: 30%;
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        font-size: 1.8em;
        z-index: 999;
        color: black;
        p {
          font-size: 1.4em;
        }
      }
      .aboutdbody {
        width: 90%;
        max-width: 1500px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .aboutbottom {
          margin-top: 4%;
          display: flex;
          align-items: flex-start;
          width: 100%;
          justify-content: space-around;

          .divbox {
            div:nth-child(1){
              /*margin-left: 4.5%;*/
              width: 97%;
              height: 50%;
              max-width: 400px;
              position: relative;
              .borderimg{
                width: 22vw;height: 256px;border: 2px #dbdbdb solid
              }
              img{
                width: 100%;
                transition: all 0.6s;    //设置动画执行的时间为0.6s
                cursor: pointer;
              }
              img:hover{
                transform: scale(1.02);     //设置图片按照比例放大1.2倍
              }
              p{
                /*position: absolute;*/
                text-align: left;
                top: 85%;
                left: 20%;
                color: black;
              }
            }
          }
        }
      }
    }
  }
  // 小于800px
  @media only screen and (max-width: 800px) {
    .aboutcontent {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 5%;
      .title {
        padding-top: 4% ;
        height: 30%;
        width: 100%;
        /*display: flex;*/
        align-items: center;
        flex-direction: column;
        font-size: 1.8em;
        z-index: 999;
        color: black;
        p {
          font-size: 1.5em;
        }
      }
      .aboutdbody {
        width: 75%;
        /*max-width: 1200px;*/
        /*display: flex;*/
        /*flex-direction: column;*/
        align-items: center;

        .aboutbottom {
          margin-top: 4%;
          /*display: flex;*/
          align-items: center;
          width: 100%;
          justify-content: space-around;

          .divbox {
            div:nth-child(1){
              /*margin-left: 4.5%;*/
              width: 97%;
              height: 50%;
              flex-direction: column;
              align-items: center;
              /*position: relative;*/
              font-size: 1.3em;
              .borderimg{
                width: 100%;height: 45vw;border: 2px #dbdbdb solid
              }
              img{
                margin-bottom: 5px;
                width: 100%;
              }
              p{
                text-align: left;
                width: 97%;
                height: 50%;
                font-size: 1.7em;
                padding-bottom: 8%;
                /*position: absolute;*/
                top: 85%;
                /*left: 20%;*/
                color: black;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/About/aboutcomponents/comIntroduction.vue